export var OrderChangeContextResponse;
(function (OrderChangeContextResponse) {
    OrderChangeContextResponse.UnchangeableOrderReasonEnum = {
        ChangeOrderCutOffPassed: 'ChangeOrderCutOffPassed',
        PaymentTypeNotSupported: 'PaymentTypeNotSupported',
        CancelledOrder: 'CancelledOrder',
        StartedPicking: 'StartedPicking',
        OrderNotFound: 'OrderNotFound',
        PaymentProviderNotSupported: 'PaymentProviderNotSupported'
    };
})(OrderChangeContextResponse || (OrderChangeContextResponse = {}));
